import editIcon from '@disy/cadenza-icons/edit.svg';
import { array } from '@disy/lib/array-util';
import type { HyperScriptButtonOptions } from '@disy/ui/button';
import { createIconButton } from '@disy/ui/button';
import { icon } from '@disy/ui/icon';

import i18n from './edit-button.properties';

export const EDIT_BUTTON_CLASS = 'start-editing';

/**
 * Create an edit button: a borderless icon button with a pencil icon, with a specific CSS class.
 *
 * The primary use of this type of button is for the inline-editing contexts, but it can be used in
 * other places as well, for example "editable" fieldsets without an inline editing context.
 *
 * @param title - Title of the button, the default is "Edit" / "Bearbeiten"
 * @param buttonOptions - Extra button options (optional), e.g. to define a click handler.
 * @return An edit button element
 */
export function createEditButton(
  title = i18n('startEditing'),
  buttonOptions: HyperScriptButtonOptions = {},
): HTMLButtonElement {
  return createIconButton(icon(editIcon), title, {
    ...buttonOptions,
    styleClass: buttonOptions.styleClass ? [...array(buttonOptions.styleClass), EDIT_BUTTON_CLASS] : EDIT_BUTTON_CLASS,
    variant: 'borderless',
    size: 's',
  });
}
